import Vue from 'vue'
import moment from "moment";
import Vuex from 'vuex'
import { PROJECT_SET,PROJECT_UNSET,FEATURE_ADD,FEATURE_REMOVE,SCENARIO_ADD, SCENARIO_TOGGLE_DONE, SCENARIO_REMOVE, VOCABULARY_RESET, VOCABULARY_SET,VOCABULARY_REMOVE,BACKGROUND_SET,BACKGROUND_RESET,VOCABULARY_SET_USED,VOCABULARY_NOUN_ADD, VOCABULARY_NOUN_REMOVE, VOCABULARY_VERB_ADD, VOCABULARY_VERB_REMOVE, DIAGRAM_SET, TASK_ADD, TASK_REMOVE, TASK_TOGGLE_DONE, TASK_SET, TASK_SET_DAYS,TASK_MARK_SCHEDULED, TASK_RESET, TASK_SET_TITLE, TASK_TOGGLE_ARCHIVE } from './mutation-types';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        project: {name: '', slug: '', description: '', tags: []},
        features: [],

        nouns: [],
        verbs: [],
        used: [],

        diagrams: {static: '{"class":"GraphLinksModel","nodeDataArray":[],"linkDataArray":[]}', dynamic: '{"class":"TreeModel", "nodeDataArray": []}'},

        tasks: []
    },

    mutations: {
        [PROJECT_SET]: (state, payload) => state.project = payload,
        [PROJECT_UNSET]: (state) => state.project = {name: '', slug: '', description: '', tags: []},

        [FEATURE_ADD]: (state, payload) => { state.features.push(payload); },
        [FEATURE_REMOVE]: (state, idx) => { state.features.splice(idx, 1); },

        [SCENARIO_ADD]: (state, payload) => { state.features[payload.idx].scenarios.push(payload.scenario); },
        [SCENARIO_TOGGLE_DONE]: (state, payload) => { state.features[payload.idx].scenarios[payload.sidx].isDone = payload.isDone; },
        [SCENARIO_REMOVE]: (state, payload) => { state.features[payload.idx].scenarios.splice(payload.sidx, 1); },

        [VOCABULARY_RESET]: state => { state.nouns = []; state.verbs = []; state.used = []; },
        [VOCABULARY_SET]: (state, payload) => {
            let i;
            i = state[payload.order[0]].indexOf(payload.tag);
            if (i===-1) {
                state[payload.order[0]].push(payload.tag);
            }
            i = state[payload.order[1]].indexOf(payload.tag);
            if (i!==-1) {
                state[payload.order[1]].splice(i, 1);
            }
        },
        [VOCABULARY_REMOVE]: (state, payload) => {
            let i = state.nouns.indexOf(payload);
            if (i !== -1) state.nouns.splice(i, 1);
            i = state.verbs.indexOf(payload);
            if (i !== -1) state.verbs.splice(i, 1);
        },
        [VOCABULARY_SET_USED]: (state, payload) => { state.used.push(payload); },
        [VOCABULARY_NOUN_ADD]: (state, payload) => { state.nouns.indexOf(payload)===-1 && state.nouns.push(payload);},
        [VOCABULARY_NOUN_REMOVE]: (state, idx) => { state.nouns.splice(idx, 1); },
        [VOCABULARY_VERB_ADD]: (state, payload) => { state.verbs.indexOf(payload)===-1 && state.verbs.push(payload);},
        [VOCABULARY_VERB_REMOVE]: (state, idx) => { state.verbs.splice(idx, 1); },

        [BACKGROUND_SET]: (state, payload) => { const p = state.features[payload.idx]; p.options.hasBackground=true; p.background=payload.background; },
        [BACKGROUND_RESET]: (state, payload) => { const p = state.features[payload]; p.options.hasBackground=false; p.background={given: '', ands:[]}; },

        [DIAGRAM_SET]: (state, payload) => { payload.isStatic ? (state.diagrams.static = payload.data) : (state.diagrams.dynamic = payload.data); },

        [TASK_ADD]: (state, payload) => { state.tasks.push(payload); },
        [TASK_REMOVE]: (state, payload) => { const i = state.tasks.findIndex(v => v.id === payload); if (i !== -1) state.tasks.splice(i, 1); },
        [TASK_TOGGLE_DONE]: (state, payload) => { const i = state.tasks.findIndex(v => v.id === payload.id); if (i !== -1) state.tasks[i].isDone = payload.isDone; },
        [TASK_SET]: (state, payload) => { const i = state.tasks.findIndex(v => v.id === payload.id); if (i !== -1) {state.tasks[i].task = payload.task; state.tasks[i].isDone = payload.isDone; } },

        [TASK_SET_DAYS]: (state, payload) => { const i = state.tasks.findIndex(v => v.id === payload.id); state.tasks[i].days=payload.days; },
        [TASK_MARK_SCHEDULED]: (state, payload) => {
            let task = state.tasks.find(v => v.id === payload.id);
            task.isScheduled = payload.v;
            task.column = payload.column;
        },
        [TASK_RESET]: (state, payload) => {let task = state.tasks.find(v => v.id === payload.id); task.isDone=false; task.isScheduled=false;},
        [TASK_SET_TITLE]: (state, payload) => {let task=state.tasks.find(v => v.id===payload.id); task.task=payload.task;},
        [TASK_TOGGLE_ARCHIVE]: (state, payload) => {let task=state.tasks.find(v => v.id===payload.id); task.isArchived=payload.isArchived;},
    },
    actions: {
        async initApp({state}, payload) {
            const db = payload.db;

            state.features = await db.features.where({pid: payload.id}).toArray();

            const vocabulary = await db.vocabularies.get({pid: payload.id});
            if (vocabulary) {
                state.nouns = vocabulary.nouns || [];
                state.verbs = vocabulary.verbs || [];
                state.used = vocabulary.used || [];
            }

            let diagrams = await db.diagrams.get({pid: payload.id});
            if (diagrams) {
                state.diagrams = diagrams;
            }

            state.tasks = await db.tasks.where({pid: payload.id}).toArray();
        },

        async addTask({state}, payload) {
            if (typeof state.project.id !== 'undefined') {
                let task = {pid: state.project.id, from: payload.from, task: payload.task, isDone: false, isScheduled: false, isAchieved: false, days: 3, column: 0, created: +moment(), updated: +moment()};
                const id = await payload.db.tasks.add(task);
                task = await payload.db.tasks.get(id);
                state.tasks.push(task);
                return id;
            }

            // TODO: something wrong here
            return 0;
        },

        // db id column v
        async taskToggleScheduled({state}, payload) {
            const db = payload.db;
            await db.tasks.update(payload.id, {column: payload.column, isScheduled: payload.v});
            this.commit(TASK_MARK_SCHEDULED, payload);
        },

        async taskReset({state}, payload) {
            const db = payload.db;
            await db.tasks.update(payload.id, {isDone: false, isScheduled: false});
            this.commit(TASK_RESET, payload);
        }
    }
})
